module.exports = __webpack_public_path__ + "media/images/hdrlogo-b03f828f35891c5487396904d78fba02.png";